export default {
    computed:{
        schemaLogo(){
            return {
                "@type": "ImageObject",
                url: "https://www.legalnature.com/apple-touch-icon.png",
              }
        },
        schemaAuthor(){
            return {
                "@type": "Organization",
                name: "LegalNature",
              }
        },
    },

    methods:{
        stripHtmlTags(html) {
            return html.replace(/<\/?[^>]+(>|$)/g, "");
          },
    }
}